var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_317_5291",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_317_5291",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB7ElEQVR4nO2ZTUoDQRCFH4ILN641gis9gQvd6XQP/usBxAN4ADHuRPEU4kq8gyAqirjSC/iTKhOXLpRR8Bcj7UyIxJ5xosjUSH/Qm6QLqvLqTcgL4HA4fk0JepKgdwnqnqGrGZ4708cl/ImmhyDo1Yybr9qPWmlKiajoiaAWyvALyJAy/AJBFU0/YV/eeKpCgt4zBaYYgqCPYT762klVYHbSFFxipBOCYAx2RCsW5N7YHN3LvbE5bpC8GZvjBsmbsTlukLwZmxMGiTdPxrClNzdIlrBTRBjsFBEGO0WEwU4RYbBTRBjsFBEGO0WEK1KB6op+lt9+e1kS3NAbw1+MzbXyMEj5SyChxmIvQyBsj4mWEy9DIFxvPjDrZFXi0+WgJh8EUUkytg0TT0rMtTjJ2DZMxvopaSxmrUw5jbHjMBlrihz2sLGuiqUWhtr/w/x3uelPwmSsoaFCz1jOc2MNwZv+g+aDb439E84x2BPuqr6xqHEcvudNQzqEof5otU7tIbM+Qh5gqLno6bFZf82fIahXswYX8HshnRP0tTLUmRmkBDV7htF2hloj6DeGeixBTUE6FQy0GRVqX0oEvW58EhnymuANIw8w9EHjE4WgXxh6Q9p/KYkw9DZBPzD0FUFtEbz5Evzu5CqHA/+Fd99nyX7za1FFAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.01846e841434a1b5bffbce4d8632a2d3.svg";
export { ForwardRef as ReactComponent };